import { AfterViewInit, Component, DoCheck, ElementRef, HostListener, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { IonTextarea, ModalController, Platform } from '@ionic/angular';
import { AppState } from 'src/app/app.service';
import { HamburgerMenuComponent } from '../hamburger-menu/hamburger-menu.component';
import { FooziAiLibraryPopupComponent } from '../foozi-ai-library-popup/foozi-ai-library-popup.component';
import { AnimationsService } from 'src/app/shared/animations.service';
import { FooziAiConciergeService } from '../foozi-ai-concierge.service';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { FullScreenRoutineComponent } from 'src/app/full-screen-routine/full-screen-routine.component';
import { duration } from 'moment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { ToasterService } from 'src/app/toaster.service';
import mixpanel from 'mixpanel-browser';
import { FullScreenFeedComponent } from 'src/app/full-screen-feed/full-screen-feed.component';
import { MobileChatBoardComponent } from 'src/app/pages/mobile-chat-board/mobile-chat-board.component';
import { HomeUiService } from '../home-ui.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FullScreenVideoComponent } from 'src/app/full-screen-video/full-screen-video.component';
import { FullScreenAudioComponent } from 'src/app/full-screen-audio/full-screen-audio.component';
import { FullScreenDocumentComponent } from 'src/app/my-library/full-screen-document.component';
import { I18n } from 'src/app/i18n.service';

@Component({
  selector: "app-foozi-ai-concierge",
  templateUrl: "./foozi-ai-concierge.component.html",
  styleUrls: ["./foozi-ai-concierge.component.scss"],
})
export class FooziAiConciergeComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  isMobile;
  isModalOpen;
  isDisableLike = false;
  isCopyContent = false;
  isMsgSaved;
  isLikeSelected = false;
  postMsg: any = "";
  chat: any = [];
  suggestions = [];
  isLoader: boolean;
  dislikeFeedback: boolean = false;
  touchStartY;
  rowCount = 1;
  messages= [];
  private timings: number[] = [];
  private typingDelay = 50;
  private messagePause = 1000; 
  private currentMessageIndex = 0;
  showFakeLastMessage: boolean = true;
  post_event_listeners = [];
   @ViewChildren("fooziDoc") fooziDoc:QueryList<ElementRef>;
  @ViewChild("hamModal") hamModal: HamburgerMenuComponent;
  @ViewChild('scrollBottom') private scrollBottom: ElementRef;
  @ViewChild('foozicardContainer') foozicardContainer: ElementRef;
  @ViewChild('textarea', { static: false }) textarea: IonTextarea;
  destroyed$ = new Subject<boolean>();
  isSessionRefreshing = false;
  videoFormats = ['.mp4', '.mov', '.avi', '.avchd', '.f4v', '.mkv', '.wmv','youtube.com', 'webm', 'html5', 'HTML5', 'watch'];
  audioFormats = [".mp3"];
  casulaDocumentsList = [];
  path;
  loaded;
  showAnimation = false;
  fooziTextAreaLabel;
  constructor(
    public platform: Platform,
    public appState: AppState,
    private modalController: ModalController,
    private animationService: AnimationsService,
    private keyboard: Keyboard,
    private renderer: Renderer2,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard,
    private toaster: ToasterService,
    private fooziAiConciergeService: FooziAiConciergeService,
    private homeUiService: HomeUiService,
    public i18n: I18n

  ) {
    this.isMobile = this.appState.get("isMobile");
    this.isModalOpen = this.appState.get("isHamburgerOpen");
    this.path = this.appState.get('currentPath');
    let loaderMessages = [ 'Interpreting your question…',
                           'Checking your progress and data sources…',
                           'Synthesizing indexed data…',
                           'Crafting your answer…'
                         ];
      loaderMessages.forEach((loaderMessage)=>{
        this.messages.push(this.i18n.t(loaderMessage));
      });
  }

  addClickEventsToPosts() {
    // Find all elements with the class 'post-link'
    const postLinks = this.el?.nativeElement?.querySelectorAll('.post-link');
    
    // Remove all existing event listeners
    this.post_event_listeners.forEach((listener) => {
      listener();
    });

    postLinks?.forEach((link) => {
      //Removed text-decoration: underline; as it is looking odd 
      link.setAttribute("style", "color: #007bff;cursor: pointer;");
      // Get the post ID from the class name
      const postId = link.querySelector("span").className;

      // Add a click event listener to each link
      let listener = this.renderer.listen(link, "click", () => {
        this.openFullScreenRoutine(parseInt(postId, 10));
      });
      this.post_event_listeners.push(listener);
    });
  }
  docLink(link) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(link)
  }
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
  ngOnInit() {
    let session = this.fooziAiConciergeService.createChatSession();
    // Check if the session_id exists in the local storage
     this.listenToKeyboardEvents();
     this.addInputEventListeners()    
    let session_id = sessionStorage.getItem('foozi_session');
    if (!session_id || this.checkIsSessionExpired()==1) {
      this.isSessionRefreshing =true
      session.subscribe((res) => {
         this.isSessionRefreshing =false
        this.fooziAiConciergeService.setsessionValidityStatus(false)
        sessionStorage.setItem('foozi_session', res.session_id);
        sessionStorage.setItem('foozi_session_expiry', res?.expires_at)
        for(let suggestion of res.common_questions) {
          this.suggestions.push(suggestion);
        }
      });
    } else {
      // Check if the session_id is expired
      this.fooziAiConciergeService.checkSessionValidity(session_id).subscribe((res) => {
        if (!res) {
          // If session_id is expired, create a new session and save it in the local storage
          session.subscribe((res) => {
            sessionStorage.setItem('foozi_session', res.session_id);
            sessionStorage.setItem('foozi_session_expiry', res?.expires_at);
          });
          this.isLoader = true;
          setTimeout(() => {
            const messages = document.querySelectorAll(".info-text");
            this.displayMessages(messages);
            this.isLoader = false;
          }, 1000);
        }
        if (res) {
          // res contains past_messages, so we can display them
           sessionStorage.setItem('foozi_session', res.session_id);
           sessionStorage.setItem('foozi_session_expiry', res?.expires_at)
          const messages = document.querySelectorAll(".info-text");
          this.displayMessagesImmediately(messages);
          let index = 0, uniqueids=[];
          for (let message of res.past_messages) {
            let role = message.role == 'assistant' ? 'foozi-response' : 'user-input';
            let classValue = message.role == 'assistant' ? 'foozi-responz-wrap' : 'justify-content-end user-input-wraper';
            let modifiedMessage = message.message.replace(
              /\[post_id-(\d+)-([\w\s.]+)-?\]/g,
              (match, postId, name) => ` (<span class="post-link"><span class=${postId}>See ${name}'s post</span></span>)`
            )?.replace(/\s*(?:\[path_id-\d+-step-\d+\]|\[s*path.*?step-\d+]|\[s*path<\/em>id-\d+-step-\d+])\s*/g, '')
            this.casulaDocumentsList = [];
            let id = []
              let source_docs= [
                    {
                        "doc_id": "5796",
                        "excerpt": "# SUCCESS BEHAVIORS\n\n### WHY IT MATTERS\n\nWe’re at our best when we learn from\neach other. Below are the examples\nshared by the group during the NSM\nStrategy Session of behaviors you’ve\nemployed to suc...",
                        "reference": "[doc_id-10724]",
                        "source": "unknown"
                    },
                    {
                      "doc_id": "4434",
                      "excerpt": "# SUCCESS BEHAVIORS\n\n### WHY IT MATTERS\n\nWe’re at our best when we learn from\neach other. Below are the examples\nshared by the group during the NSM\nStrategy Session of behaviors you’ve\nemployed to suc...",
                                "reference": "[doc_id-10724]",
                                "source": "unknown"
                    }
              ]
            // message.source_docs =source_docs
            if (message?.source_docs?.length > 0) {
              id = [];
              this.loaded=false
              message?.source_docs?.forEach((doc) => {
                id.push(+doc?.doc_id)
              })
            }
            this.chat.push({
              role: role,
              message: modifiedMessage,
              documentId: role == 'foozi-response' && id?.length>0 ? id : null,
              class: classValue,
              noop: true
            });
              if (id && id?.length > 0 && role == 'foozi-response' && res.past_messages?.length-1!=index) {
               uniqueids =[...id, ...uniqueids]
                uniqueids = [...new Set(uniqueids)]
              }
             if (id && id?.length > 0 && role == 'foozi-response' && res.past_messages?.length-1==index) {
               uniqueids =[...id, ...uniqueids]
                uniqueids = [...new Set(uniqueids)]
               // this.openFullScreenCasualDocuments(uniqueids)
               this.fetchCasualDocuments(uniqueids)
              }

            index++;
            // console.log("this.chat", this.chat, uniqueids)
            setTimeout(() => {
              this.addClickEventsToPosts();
            }, 0);
          }
          for (let suggestion of res.common_questions) {
            this.suggestions.push(suggestion);
          }
          setTimeout(() => {
            this.scrollToLastMessage();
          }, 800);    
          if (this.chat && this.chat.length > 0) {
            this.chat[this.chat.length - 1].noop = false;
          }
          // this.scrollBottom.nativeElement.scrollTop = this.scrollBottom.nativeElement.scrollHeight;
          // if (this.scrollBottom?.nativeElement) {
          //    this.scrollBottom.nativeElement.scrollTop = this.scrollBottom?.nativeElement?.scrollHeight;
          //  }
        }
      }
      );
    }
    this.fooziAiConciergeService.sessionValidityStatus.pipe(takeUntil(this.destroyed$)).subscribe((res) => {
      session_id = sessionStorage.getItem('foozi_session')
      let session;
      if (session_id && res==2) {
        session = this.fooziAiConciergeService.checkSessionValidity(session_id)
      }
      else if(res==1) {
        session = this.fooziAiConciergeService.createChatSession();
      }
      if (res && !this.isSessionRefreshing) {
         this.isSessionRefreshing =true
        session.pipe(takeUntil(this.destroyed$)).subscribe((res) => {
          this.fooziAiConciergeService.setsessionValidityStatus(false)
          this.isSessionRefreshing =false
        mixpanel.track("New session id was set after expiry in same acive tab", { 'sessionexpiryTimeLocal': res?.expires_at})
        sessionStorage.setItem('foozi_session', res.session_id);
        sessionStorage.setItem('foozi_session_expiry', res?.expires_at)
          
        },
          (err) => {
          this.isSessionRefreshing =false
        });
      }
    })

  
  }
    removeBracketContentFromHtml(content: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const pTags = doc.querySelectorAll('p');

    pTags.forEach((p) => {
      p.textContent = p.textContent?.replace(/\s*\[path_id-\d+-step-\d+\]\s*/g, '').trim();
    });

    return doc.body.innerHTML;
  }
   addInputEventListeners() {
    const inputs = document.querySelector("textarea");
    const element = document.querySelector(".mob") as HTMLElement;
    const element2 = document.querySelector(".mob-ai-continer-scroll-y") as HTMLElement
    if (inputs && this.platform.is("mobileweb") && element || element2) {
      this.renderer.listen(inputs, "focus", () => {
        element.style.bottom = "25px";
        element2.style.height = "calc(100vh - 270px)";
      }); 

      this.renderer.listen(inputs, "blur", () => {
        element.style.bottom = "45px";
        if(this.platform.is('android')) {
          element2.style.height = "calc(100vh - 203px)";
        }
        if (this.platform.is('ios')) {
           element2.style.height = "calc(100vh - 275px)";
        }
       
      });
      this.renderer.listen(inputs, "focusout", () => {
        element.style.bottom = "45px";
          if(this.platform.is('android')) {
          element2.style.height = "calc(100vh - 203px)";
        }
        if (this.platform.is('ios')) {
           element2.style.height = "calc(100vh - 275px)";
        }
      });
    }

   }
  
  checkIsSessionExpired() {
     let session_id = sessionStorage.getItem('foozi_session');
    let sessionexpiry = sessionStorage.getItem('foozi_session_expiry')
    let givenTime,hours,minutes ;
    if (sessionexpiry && sessionexpiry != undefined) {
      givenTime = new Date(sessionexpiry);
      // Convert UTC to IST
       hours = givenTime.getHours() + 5;
       minutes = givenTime.getMinutes() + 30;

      // Handle overflow when minutes exceed 60
      if (minutes >= 60) {
        hours += 1;
        minutes -= 60;
      }
      // Handle hours overflow (crossing midnight)
      if (hours >= 24) {
        givenTime.setDate(givenTime.getDate() + 1); // Move to next day
        hours -= 24; // Reset hour within 24-hour range
       }
      givenTime.setHours(hours);
      givenTime.setMinutes(minutes);
     //sessionexpiryTimeLocal = new Date(givenTime.toLocaleString());
    }
    else {
      givenTime =0
    }
    const currentTime = new Date();
    let timeDifference;
    if (givenTime && givenTime!=0) {
      timeDifference = givenTime?.getTime() - currentTime?.getTime();
    }

    // Convert milliseconds to minutes
    const minutesPassed = timeDifference / (1000 * 60);
    if (!session_id || (givenTime < currentTime || givenTime == 0)) {
      return 1
    }
    else if (minutesPassed >= 0 && minutesPassed <=
      3) {
      return 2
    }
    else {
      return 0;
    }
  }
  
  ngDoCheck(): void {
      if (this.checkIsSessionExpired()==2 && !this.isSessionRefreshing) {
        this.fooziAiConciergeService.setsessionValidityStatus(2)
    } 
      else if (this.checkIsSessionExpired() ==1 && !this.isSessionRefreshing) {
        this.fooziAiConciergeService.setsessionValidityStatus(1)
    }
    if (this.appState.get('isDocumentOpenedFromFoozi') == true) {
      this.appState.set('isDocumentOpenedFromFoozi', undefined);
      let ids= this.casulaDocumentsList.map((doc)=>doc.id)
      let id =this.appState.get('singleDocument')?.id
      this.openFullScreenCasualDocuments(id)
     // this.fetchCasualDocuments(id)
    }
  }
   removeInputEventListeners() {
    const inputs = document.querySelector("textarea");
    if (inputs) {
       this.renderer.listen(inputs, "focus", null);
       this.renderer.listen(inputs, "blur", null);
       this.renderer.listen(inputs, "focusout", null);
    }
   
  }

  listenToKeyboardEvents() {
    this.keyboard.onKeyboardDidShow().subscribe((event: any) => {
      const keyboardHeight = event.keyboardHeight;
      this.adjustForKeyboard(true, keyboardHeight);
    });

    this.keyboard.onKeyboardWillHide().subscribe(() => {
      this.adjustForKeyboard(false, 0);
    });
  }


  adjustForKeyboard(isKeyboardVisible: boolean, keyboardHeight: number ) {
    const element = document.querySelector('.mob') as HTMLElement;
    const element2 = document.querySelector(".mob-ai-continer-scroll-y") as HTMLElement;
    if (element || element2) {
      if (isKeyboardVisible) {
        if (this.platform.is('ios')) {
            element.style.bottom = `${keyboardHeight + 8}px`; // Remove bottom spacing
            element2.style.height = `calc(100vh - ${keyboardHeight}px - 153px )`;
        }
        else if (this.platform.is('android')) {
          element.style.bottom = `${keyboardHeight + 41}px`;
          element2.style.height = `calc(100vh - ${keyboardHeight}px - 166px )`;
        }
      } else {
        if (this.platform.is('ios')) {
          element.style.bottom = "7%";
          element2.style.height ='calc(100vh - 195px)';
        }else if (this.platform.is('android')) {
          element.style.bottom = "45px";
          element2.style.height ='calc(100vh - 168px)';
        }       
      }
    }
  }

  ngAfterViewInit(): void {
    this.fooziTextAreaLabel = this.i18n.t("Message Kyper Coach");
    console.log("this.fooziTextAreaLabel", this.fooziTextAreaLabel, this.i18n.t("What impact do you expect—or have you already seen—as a result of this action?"));
  }

  private capitalizeSentences(text: string): string {
    return text.replace(/(?:^|\.\s)([a-z])/g, (match) => match.toUpperCase());
  }
  adjustTextareaHeight(event): void {
    const textareaElement = this.textarea.getInputElement();
    let ele = document.getElementsByClassName("foozi-dynamic-textarea");
    const lineHeight = parseFloat(getComputedStyle(this.textarea['el']).lineHeight);
    if (event && event.target.value) {
      this.postMsg = this.capitalizeSentences(event.target.value);
    }
    textareaElement.then((textarea: HTMLTextAreaElement) => {
      let maxHeight;
      if (this.isMobile) {
        maxHeight = Math.min(window.innerHeight * 0.4, lineHeight * 10);
      }
      else {
        maxHeight = lineHeight * 10;
      }
      const currentScrollTop = textarea.scrollTop;
      textarea.style.height = "auto";
      textarea.style.overflow = "hidden";
      textarea.style.height = textarea.scrollHeight + "px";
      if (textarea.scrollHeight > maxHeight) {
        textarea.style.overflow = "auto";
        textarea.style.height = maxHeight + "px";
      }
      this.rowCount = Math.ceil(textarea.scrollHeight / lineHeight);
      if (this.rowCount > 1 && ele) {
        if (this.isMobile) {
          ele[0].setAttribute("style", "margin-bottom:0px !important;");
        }
        else {
         ele[0].setAttribute("style", "margin-bottom:12px !important;");
        }
      }
      else {
          ele[0].setAttribute("style", "margin-bottom:-20px !important;");
      }
      textarea.offsetHeight; // Trigger reflowg
      // Check if the user is at the bottom of the textarea
      const isAtBottom =
        textarea.scrollHeight - textarea.scrollTop <=
        textarea.clientHeight + 1;
      if (isAtBottom) {
        // Scroll to the bottom
        textarea.scrollTop = textarea.scrollHeight;
      } else {
        // Restore the previous scroll position if not near the bottom
        textarea.scrollTop = currentScrollTop;
      }
    });
  }

  // scrollToLastMessage() {
  //   this.foozicardContainer.nativeElement.scrollTop =
  //     this.foozicardContainer.nativeElement.scrollHeight;
  // }


  // after asking que to the foozi scroll up
  scrollToLastMessage1() {
    if (this.foozicardContainer) {
      // console.log('scrollToLastMessage1', Math.random());
      const container = this.foozicardContainer?.nativeElement;
      container.scrollTo({ top: container.scrollHeight, behavior: 'smooth', duration:100 });
    }
  }

  // on open foozi last response fixed to the top
  scrollToLastMessage() {
    if (this.foozicardContainer) {
      // console.log('scrollToLastMessage', Math.random());
      const container = this.foozicardContainer.nativeElement as HTMLElement;
      const contentParent = document.getElementById('content');
      if (!contentParent) {
        console.warn('Parent element with id="content" not found');
        return;
      }
      // Find the last element with class 'foozi-response' inside the container
      const messages = container.querySelectorAll('.foozi-response');
      if (messages.length === 0) {
        console.warn('No elements with class "foozi-response" found inside container');
        return;
      }
      const lastMessage = messages[messages.length - 1] as HTMLElement;
      const contentRect = contentParent.getBoundingClientRect();
      const lastMessageRect = lastMessage.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const offsetDifference = lastMessageRect.top - contentRect.top;
      
      const scrollToPosition = container.scrollTop + offsetDifference - 25;
      container.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }
  
  // while getting response from the foozi scroll to the bottom
  scrollToLastMessage2() {
    // Assuming the chat container has a class 'chat-container'
    const chatContainer = document.querySelector('#scrollBottom');
    if (!chatContainer) return; // Exit if container not found

    // console.log('scrollToLastMessage2', Math.random());
    // Scroll to the bottom smoothly
    chatContainer.scrollTo({
      top: chatContainer.scrollHeight,
      behavior: 'smooth'
    });
  }



  displayMessages(messages) {
    let delay = 0;
    messages.forEach((message, index) => {
      setTimeout(() => {
        message.style.display = "block";
      }, delay);
      delay += 1000; // Adjust delay between messages (in milliseconds)
    });
  }
  displayMessagesImmediately(messages) {
    messages.forEach((message, index) => {
      message.style.display = "block";
    });
  }

  //chat = [
  //   {
  //     role: 'user-input',
  //     message: 'I heard there was a recent discussion about motivating teams. Can you summarize the main points from that conversation?',
  //     class: 'justify-content-end user-input-wraper'
  //   },
  //   {
  //     role: 'foozi-response',
  //     message: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s,',
  //     class: 'foozi-responz-wrap'
  //   },
  //   // more conversations here
  // ];
  changeSubTextFont(index) {
    if (this.fooziDoc) {
      const element = this.fooziDoc.toArray()[index]?.nativeElement;
      const specificElement = element?.querySelector('p') || element?.querySelector('h1') || element?.querySelector('h2');
      if (specificElement) {
        this.renderer.setStyle(specificElement, 'font-size', '14px');
        this.renderer.setStyle(specificElement, 'font-weight', '500');
        this.renderer.setStyle(specificElement, 'font-style', 'normal');
        this.renderer.setStyle(specificElement, 'line-height', '19px');
        this.renderer.setStyle(specificElement, 'font-family', 'Roboto');
        this.renderer.setStyle(specificElement, 'align-items', 'center');
         this.renderer.setStyle(specificElement, 'dispaly', 'flex');
        this.renderer.setStyle(specificElement, 'padding', '0px');
        this.renderer.setStyle(specificElement, 'margin', '0px');
      }
    }
    return 0
  }
  resetTextareaHeight(): void {
    const textareaElement = this.textarea.getInputElement();
    textareaElement.then((textarea: HTMLTextAreaElement) => {
      textarea.style.height = 'auto'; // Reset to the default size
      textarea.style.overflow = 'hidden'; // Hide the scrollbar initially
      // textarea.setAttribute("style", "margin-bottom:-20px");      
    });
  }
  onTextModification(ev) {
    // console.log("called on change", ev.target.value);
    this.adjustTextareaHeight(ev)
  }
  sendMsg(event = null, suggestion = null) {
    if (this.showAnimation) return;
  let user = this.appState.get("currentUser");
  mixpanel.track('Foozi message', {
    message: this.postMsg
  });
  this.resetTextareaHeight();
  setTimeout(() => {
    this.scrollToLastMessage1();
  }, 100);
  this.textarea.autofocus = false;
  this.textarea['el'].blur();
  if (this.isMobile && this.keyboard.isVisible) {
    this.keyboard.hide();
  }
  if (this.dislikeFeedback && suggestion == null) {
    this.chat.push({
      role: 'user-input',
      message: this.postMsg,
      class: 'justify-content-end user-input-wraper'
    });
    let response = this.chat[this.chat.length - 3].message;
    let prompt = this.chat[this.chat.length - 4].message;
    this.fooziAiConciergeService.sendLike(response, prompt, this.postMsg, 'false').subscribe((res) => {
      // console.log(res);
      // setTimeout(() => {
      //   this.scrollToLastMessage();
      // }, 200);
    });
    this.dislikeFeedback = false;
    this.chat.push({
      role: 'foozi-response',
      message: "Thank you for your feedback. I will use it to improve my service.",
      class: 'foozi-responz-wrap',
      noop: true
    });
    this.postMsg = "";
    return;
  }
  if (suggestion) {
    this.postMsg = suggestion;
  }
  this.dislikeFeedback = false;
  // console.log("sendMsg", this.postMsg);
  this.chat.push({
    role: 'user-input',
    message: this.postMsg,
    class: 'justify-content-end user-input-wraper'
  });
    this.isLoader = true;
    this.showAnimation = true;
  // if (this.isLoader) {
  //  this.startTypingSequence();
  // }
  let postMsg = this.postMsg;
  this.postMsg = "";
  this.fooziAiConciergeService.sendMessage(sessionStorage.getItem('foozi_session'), postMsg).subscribe((res) => {
    // console.log(res);
    sessionStorage.setItem('foozi_session_expiry', res?.expires_at);
    setTimeout(() => {
      // this.scrollToLastMessage();
      this.isLikeSelected = false;
    }, 200);
    if (this.chat.length > 2) {
      this.chat[this.chat.length - 2].noop = true;
    }
    let modifiedMessage = res.past_messages[res.past_messages.length - 1].message.replace(
      /\[post_id-(\d+)-([\w\s.]+)-?\]/g,
      (match, postId, name) => ` (<span class="post-link"><span class=${postId}>See ${name}'s post</span></span>)`
    )?.replace(/\s*(?:\[path_id-\d+-step-\d+\]|\[s*path.*?step-\d+]|\[s*path<\/em>id-\d+-step-\d+])\s*/g, '');
    let id = [];
    let source_docs= [
                    {
                        "doc_id": "5796",
                        "excerpt": "# SUCCESS BEHAVIORS\n\n### WHY IT MATTERS\n\nWe’re at our best when we learn from\neach other. Below are the examples\nshared by the group during the NSM\nStrategy Session of behaviors you’ve\nemployed to suc...",
                        "reference": "[doc_id-10724]",
                        "source": "unknown"
                    },
                    {
                      "doc_id": "4434",
                      "excerpt": "# SUCCESS BEHAVIORS\n\n### WHY IT MATTERS\n\nWe’re at our best when we learn from\neach other. Below are the examples\nshared by the group during the NSM\nStrategy Session of behaviors you’ve\nemployed to suc...",
                                "reference": "[doc_id-10724]",
                                "source": "unknown"
                    }
      ];
    // this is for testing comment after testing
    // res.past_messages[res.past_messages.length - 1].source_docs = source_docs;

    if (res.past_messages[res.past_messages.length - 1]?.source_docs?.length > 0) {
      this.loaded = false;
      res.past_messages[res.past_messages.length - 1]?.source_docs?.forEach((doc) => {
        id.push(+doc?.doc_id);
      });
    }
    // Push empty message to start typing effect
    // setTimeout(() => {
      this.chat.push({
        role: 'foozi-response',
        message: '',
        documentId: id?.length > 0 ? id : null,
        class: 'foozi-responz-wrap last-msg-scroll',
        noop: true
      });
      const lastChatIndex = this.chat.length - 1;
      this.typeWriterEffect(modifiedMessage, lastChatIndex, 5, id); // 15ms per character
    
      this.isLoader = false; // when we add timeout
      this.scrollToLastMessage(); // added at the last
      // }, 14000);
    // if (id && id.length > 0) {
    //   this.fetchCasualDocuments(id);
    // }
 
    // this.isLoader = false;
  },(error)=>{
    this.isLoader = false;
    this.showAnimation = false;
  });
}
typeWriterEffect(fullText: string, chatIndex: number, speed: number = 5, id) {
  let currentIndex = 0;
  const interval = setInterval(() => {
    if (currentIndex < fullText.length) {
      this.chat[chatIndex].message += fullText[currentIndex];
      currentIndex++;
      // Optional: Auto-scroll while typing
      this.scrollToLastMessage();
    } else {
      clearInterval(interval);
      setTimeout(() => {
      this.addClickEventsToPosts();
     }, 0);
      if (id && id.length > 0) {
        this.fetchCasualDocuments(id);
      }
      this.chat[chatIndex].noop = false;
      setTimeout(() => {
        this.scrollToLastMessage();
        this.showAnimation = false;
      }, 100);
    }
  }, speed);
}

  //  startTypingSequence() {
  //   this.generateTimings();

  //   this.messages.forEach((message, index) => {
  //     setTimeout(() => {
  //       this.typeMessage(message);
  //     }, this.timings[index]);
  //   });
  // }

  // private generateTimings(): void {
  //   this.timings = [];
  //   let currentTime = 0;

  //   const specificTimings = [2000, 6000, 4000, 2000];

  //   this.messages.forEach((msg, index) => {
  //       if (index < specificTimings.length) {
  //           this.timings.push(currentTime);
  //           currentTime += specificTimings[index] + this.messagePause; // Add pause after each message
  //       }
  //   });
  // }

  typeMessage(message: string) {
    const el = document.getElementById('typing-text');
    const cursor = document.getElementById('cursor');
    if (!el || !cursor) return;

    el.textContent = '';
     cursor.style.display = 'inline';
    let charIndex = 0;

    const interval = setInterval(() => {
      if (charIndex < message.length) {
        el.textContent += message.charAt(charIndex);
        charIndex++;
        this.scrollToLastMessage2();
      } else {
        clearInterval(interval);
        // this.moveToNextMessage();
      }
    }, this.typingDelay);
  }
// new code END
  closePage() {
    this.modalController.dismiss();
  }

  getFileIcon(type: string): string {
    switch (type) {
      case 'pdf': return 'assets/icon/pdf.svg';
      case 'video': return 'assets/icon/video.svg';
      case 'audio': return 'assets/icon/video.svg';
      default: return 'assets/icon/file.svg';
    }
  }
  async click() {
    this.appState.set("isHamburgerOpen", true);
    this.isModalOpen = this.appState.get("isHamburgerOpen");
    // console.log("called click event", this.isModalOpen);
  }
  closeHamModal() {
    this.appState.set("isHamburgerOpen", false);
    this.isModalOpen = this.appState.get("isHamburgerOpen");
    this.hamModal.closeHamModal();
  }
  async openFooziAiPopup() {
    const modal = await this.modalController.create({
      component: FooziAiLibraryPopupComponent,
      enterAnimation: this.animationService.slideInUpEnterAnimation,
      leaveAnimation: this.animationService.slideOutDownLeaveAnimation,
      cssClass: this.isMobile
        ? "m-foozi-Ai-library-popup"
        : "web-foozi-Ai-library-popup",
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res?.data?.isMsgSaved) {
        this.isMsgSaved = true;
      }
    });
  }
  // disableLike() {
  //   this.isDisableLike = true;
  //   this.chat.push({
  //     role: 'foozi-response',
  //     message: "<ion-text class=\"dislike-respond\"> I’m sorry you don’t like that response. Please provide feedback about your experience so that my service can be improved. </ion-text>",
  //     class: 'foozi-responz-wrap'
  //   });
  //   setTimeout(() => {
  //     this.isDisableLike = false;
  //   }, 3000);
  //   console.log("isDisableLike", this.isDisableLike);
  // }
  like() {
    this.isLikeSelected = !this.isLikeSelected;
    // last two messages are the user input and the response from foozi
    let response = this.chat[this.chat.length - 1].message;
    let prompt = this.chat[this.chat.length - 2].message;
    this.fooziAiConciergeService.sendLike(response, prompt).subscribe((res) => {
      // console.log(res);
    });
    // console.log("like", this.isLikeSelected);
  }
  isDocumentAvailableInPath(docId) {
     let documents =this.appState.get("casualDocuments")
    let filteredDocuments = []
    if (docId?.length > 0) {
      filteredDocuments = documents?.filter(doc =>
        docId?.includes(doc?.id)
      );
    }
    else {
      filteredDocuments = documents?.filter(doc =>docId==doc?.id);
    }
    return filteredDocuments;
  }

  fetchCasualDocuments(docId) {
    //docId = docId?.length > 1 ? JSON.stringify(docId) : docId;
     let documents =this.appState.get("casualDocuments")
    let filteredDocuments = []
    filteredDocuments=documents?.filter(doc =>
                 docId?.includes(doc?.id)
    );
      filteredDocuments?.forEach((doc) => {
         if ((doc?.is_recommended && doc?.is_recommended === true) || (doc?.isrecommended && doc?.isrecommended ===true)) {
        const url = doc.link;
        let type;
        if (this.audioFormats.some(el => url.includes(el))) {
          type = 'audio'
        }
        else if (this.videoFormats.some(el => url.includes(el))) {
          type = 'video'
        }
        else {
          type = 'pdf'
        }
           const index = this.casulaDocumentsList?.findIndex(item => item.id === doc?.id) ;
          
               let casulaDocumentsList = this.casulaDocumentsList;
           if (index != -1) {
             casulaDocumentsList[index] = { ...doc, type: type, safeLink: doc?.editedDocumentUrl ? this.docLink(doc?.editedDocumentUrl) : this.docLink(url) };
           }
           else {
             casulaDocumentsList.push({ ...doc, type: type, safeLink: doc?.editedDocumentUrl ? this.docLink(doc?.editedDocumentUrl) : this.docLink(url) });
           }
              casulaDocumentsList = casulaDocumentsList.filter((item, index, self) =>
          index === self.findIndex(t => t.id === item.id)
             );
           this.casulaDocumentsList = [...casulaDocumentsList];
           this.chat.forEach((msg, index) => {
             if (msg.role === 'foozi-response' && Array.isArray(msg.documentId)) {
               const matchedDocs = this.casulaDocumentsList.filter(doc =>
                 msg.documentId.includes(doc.id)
               );
               this.chat[index] = {
                 ...msg,
                 documents: matchedDocs
               };
             }
           });
           if (this.scrollBottom?.nativeElement) {
             this.scrollBottom.nativeElement.scrollTop = this.scrollBottom?.nativeElement?.scrollHeight;
           }
            // setTimeout(() => {
            //     this.scrollToLastMessage(); 
            // },800)
      }     
      })
      this.loaded = true;
  }

  openFullScreenCasualDocuments(docId) {
    if (this.isDocumentAvailableInPath(docId)?.[0]?.id == docId || this.isDocumentAvailableInPath(docId)?.length ==docId?.length) {
       docId = docId?.length > 1 ? JSON.stringify(docId) : docId;
      this.fooziAiConciergeService.fetchDocumentDetails(docId).subscribe(async (res) => {
        if (res) {
          res['documents']?.forEach((doc) => {
            if ((doc?.is_recommended && doc?.is_recommended === true) ||(doc?.isrecommended && doc?.isrecommended ===true)) {
              const url = doc.link;
              let type;
              if (this.audioFormats.some(el => url.includes(el))) {
                type = 'audio'
              }
              else if (this.videoFormats.some(el => url.includes(el))) {
                type = 'video'
              }
              else {
                type = 'pdf'
              }
              // this.casulaDocumentsList= this.casulaDocumentsList?.filter(item => item.id !== doc.id)
              const index = this.casulaDocumentsList?.findIndex(item => item.id === doc?.id);
              let casulaDocumentsList = this.casulaDocumentsList;
           if (index != -1) {
             casulaDocumentsList[index] = { ...doc, type: type, safeLink: doc?.editedDocumentUrl ? this.docLink(doc?.editedDocumentUrl) : this.docLink(url) };
           }
           else {
             casulaDocumentsList.push({ ...doc, type: type, safeLink: doc?.editedDocumentUrl ? this.docLink(doc?.editedDocumentUrl) : this.docLink(url) });
           }
              casulaDocumentsList = casulaDocumentsList.filter((item, index, self) =>
          index === self.findIndex(t => t.id === item.id)
             );
           this.casulaDocumentsList = [...casulaDocumentsList];
              this.chat = this.chat.map(msg => {
                if (msg.role === 'foozi-response' && Array.isArray(msg.documentId)) {
                  const matchedDocs = this.casulaDocumentsList.filter(doc =>
                    msg.documentId.includes(doc.id)
                  );
                  return {
                    ...msg,
                    documents: matchedDocs  // New field with full document details
                  };
                }
                return msg;
              });
              this.chat.forEach((msg, index) => {
                if (msg.role === 'foozi-response' && Array.isArray(msg.documentId)) {
                  const matchedDocs = this.casulaDocumentsList.filter(doc =>
                    msg.documentId.includes(doc.id)
                  );
                  this.chat[index] = {
                    ...msg,
                    documents: matchedDocs
                  };
                }
              });
              if (this.scrollBottom?.nativeElement) {
                this.scrollBottom.nativeElement.scrollTop = this.scrollBottom?.nativeElement?.scrollHeight;
              }
            }
            setTimeout(() => {
                this.scrollToLastMessage(); 
            },800)
          })
           this.loaded = true;
        }
      },
        (error) => {
          this.loaded = true;
        }
      )
    }
    else {
      this.loaded = true;
    }
  }
  openDocument(post) {
    // console.log('post :', post);
    let journalPathName = this.path.userGroup.name
    let doc = this.appState.get('singleDocument');
    this.appState.set('singleDocument', post)
    this.appState.set('journalPost', undefined)
    if ((post.is_recommended && post.is_recommended === true) || (post?.isrecommended && post?.isrecommended ===true)) {
      this.appState.set('isCasualDocument', true)
    }
    this.appState.set('journalPathName', journalPathName)
    this.appState.set('journalStepNumber', post.startDay)
    const url = post.link;
    this.appState.set('isDocumentOpenedFromFoozi', false);
    if (this.audioFormats.some(el => url.includes(el))) {
      // console.log('Audio File', this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.homeUiService.openNextComponent(FullScreenAudioComponent, { data: post })
      } else {
        this.homeUiService.openNextComponent(FullScreenAudioComponent, { data: post }, 'desktop-library-custom')
      }
    } else if (this.videoFormats.some(el => url.includes(el))) {
      // console.log('Video File', this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.homeUiService.openNextComponent(FullScreenVideoComponent, { data: post })
      } else {
        this.homeUiService.openNextComponent(FullScreenVideoComponent, { data: post }, 'desktop-library-custom')
      }
  
    } else {
      // console.log('Document', this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.homeUiService.openNextComponent(FullScreenDocumentComponent)
      } else {
        this.homeUiService.openNextComponent(FullScreenDocumentComponent, '', 'desktop-library-custom')
      }
  
    }
  }
    
  //Open Full Screen Routine
  openFullScreenRoutine(postId: number) {
    this.fooziAiConciergeService.getPostID(postId).subscribe(async (res) => {
      this.fooziAiConciergeService.getPostReplies(res["data"]["root_id"], res["data"]["mode"], res["data"]["path_id"],postId).subscribe(async (res2) => {
        let singleTask = res2['data'];
        let mode = singleTask["type"];
        if (this.isMobile) {
         if (mode == "Routine") {
           this.openRoutineFeed(singleTask,postId);
         } else if (mode == "Question") {
           this.openHabitQuestionFeed(singleTask, mode?.toLowerCase(),postId);
         } else if (mode == "Habit") {
           this.openHabitQuestionFeed(singleTask, mode?.toLowerCase(), postId);
         }
        }  
        else {
           const modal = await this.modalController.create({
             component: MobileChatBoardComponent,
             cssClass: "desktop-custom-modal",
             componentProps: { data: { isFocus: false, post: singleTask, replyId: postId } },
             enterAnimation: this.animationService.slideInLeftEnterAnimation,
             leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,
           });
           this.homeUiService.setModalStack(modal);
           await modal.present();
           modal.onDidDismiss().then(() => {
             this.isModalOpen = false;
           });
        }
       
      });
    });
  }
  async openHabitQuestionFeed(singleTask, mode, replyId) {
    let selectedOption = this.appState.updateAcrossSteps(this.appState
      .get("DailyStepsData")
      ,mode + "s", singleTask.id, {
        votesCounts: singleTask.votescount,
      });

    if (selectedOption) {
      const data = {
        question: singleTask,
        modes: mode,
      };
      this.appState.set("singleFeed", data);
      // console.log("singleFeed :", data);
      this.appState.set("singleHabit", singleTask);
    }

    const modal = await this.modalController.create({
      component: FullScreenFeedComponent,
      // animated: false,
      componentProps: { data: singleTask, focuseTextArea: false, replyId: replyId },
      cssClass: 'custom-modal',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,

    })
    await modal.present()
  }
  async openRoutineFeed(singleTask, replyId) {
    let selectedOption = this.appState.updateAcrossSteps(this.appState
      .get("DailyStepsData")
      ,"routineInfo", singleTask['routine_info_id'], {
        votesCounts: singleTask['votescount'],
      });

    if (selectedOption) {
      const dataFeed = {
        routine: singleTask,
        mode: "routineInfo",
      };

      this.appState.set("singleFeed", dataFeed);
    }

    let data = {
      mode: 'routineInfo',
      singleRoutine: singleTask
    }
    this.appState.set("singleRoutineFeed", data);

    const modal = await this.modalController.create({
      component: FullScreenRoutineComponent,
      animated: false,
      componentProps: { data: singleTask, focuseTextArea: true, replyId: replyId },
      cssClass: 'custom-modal',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation,
    })
    await modal.present();
  }
  dislike() {
    this.dislikeFeedback = true;
    this.isLikeSelected = false;
     if (this.chat.length >= 1) {
       this.chat[this.chat.length - 1].noop = true;
     }  
     const msg =this.i18n.t('I’m sorry you don’t like that response. Please provide feedback about your experience so that my service can be improved.')  
    this.chat.push({
      role: 'foozi-response',
      message: `<ion-text class=\"dislike-respond\"> ${msg} </ion-text>`,
      class: 'foozi-responz-wrap',
      noop: true
    });
     setTimeout(() => {
       this.scrollToLastMessage();
     }, 200);
    // console.log("dislike", this.dislikeFeedback);
  }
   extractPlainTextFromHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }
  async copyContent(text) {
    
   if (this.platform.is('cordova')) {
      try {
        await this.clipboard.copy(this.extractPlainTextFromHtml(text)).then(() => {
          this.isCopyContent = true;
        })
      } catch (error) {
        this.toaster.error(this.i18n.t('Error copying to clipboard with Cordova'));
      }
    } else {
      try {
        await navigator.clipboard.writeText(this.extractPlainTextFromHtml(text)).then(() => {
          this.isCopyContent = true;
        })
      } catch (error) {
         this.toaster.error(this.i18n.t('Error copying to clipboard with web API'));
      }
   }
     setTimeout(() => {
       this.isCopyContent = false;
     }, 700);
  }
   @HostListener('touchstart', ['$event'])
   onTouchStart(event: TouchEvent) {
    if (this.platform.is('ios')) {
      this.touchStartY = event.touches[0].clientY;
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    let ele = document.getElementsByClassName("foozi-dynamic-textarea");
    if (this.rowCount > 1 && ele) {
      // ele[0].setAttribute("style", "margin-bottom:5px !important;");
    } else {
      // ele[0].setAttribute("style", "margin-bottom:-20px !important;");
    }
    if (this.platform.is('mobileweb')) {
      this.addInputEventListeners();    
    } 
    if (this.platform.is("ios") || this.platform.is("android")) {
      const touchEndY = event.changedTouches[0].clientY;
      // console.log("this.touchStartY, touchEndY", this.touchStartY, touchEndY);
      // Check if the touch started and ended at the top of the screen
      if (this.touchStartY < 65 && touchEndY < 65) {
        this.scrollToTop();
      }
    }
  }
  @HostListener("click", ["$event"])
  onLinkClick(e) {
   if (this.platform.is("mobileweb")) {
      this.addInputEventListeners();
    }
  }

  scrollToTop() {
    if (this.foozicardContainer) {
      const container = this.foozicardContainer.nativeElement;
      if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth', duration:200 });
      }
    }
  }
  ngOnDestroy(): void { 
    this.removeInputEventListeners()
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
